// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-terms-of-use {
  max-height: 90vh;
  max-width: 100%;
}
.modal-terms-of-use .ant-modal-content {
  padding: 15px;
}
.modal-terms-of-use .modal-terms-of-use-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modal-terms-of-use .modal-terms-of-use-content .modal-terms-of-use-regulation {
  max-height: 600px;
  margin: 0 auto;
  overflow-x: auto;
  width: 100%;
  height: 100%;
}
.modal-terms-of-use .modal-terms-of-use-content .title {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 0;
}
.modal-terms-of-use .modal-terms-of-use-content .icon-show-terms {
  font-style: normal;
  display: flex;
  cursor: pointer;
  max-width: 20%;
}
.modal-terms-of-use .modal-terms-of-use-content .icon-show-terms .anticon-left {
  margin-right: 3px;
}
@media screen and (max-width: 370px) {
  .modal-terms-of-use .modal-terms-of-use-content .icon-show-terms {
    font-size: 8px;
    max-width: 30%;
  }
}
.modal-terms-of-use .modal-terms-of-use-content .icon-show-terms:hover {
  color: #0059ff;
}
.modal-terms-of-use .modal-terms-of-use-content .modal-terms-of-use-buttons-container {
  display: flex;
  justify-content: flex-end;
}
.modal-terms-of-use .modal-terms-of-use-content .container-checkbox {
  display: flex;
  justify-content: center;
}
.modal-terms-of-use .modal-terms-of-use-content .container-checkbox .ant-checkbox {
  margin-right: 8px;
}
.modal-terms-of-use .modal-terms-of-use-content .container-checkbox .txt-terms {
  font-weight: bold;
}
@media screen and (max-width: 480px) {
  .modal-terms-of-use-recharge .ant-modal-content {
    padding: var(--spacing-regular) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Modal/ModalTermOfUseStyles.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;AAHA;EAMI,aAAA;AAAJ;AANA;EASI,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AAXA;EAcM,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAN;AAlBA;EAsBM,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AADN;AAzBA;EA8BM,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAFN;AA/BA;EAoCU,iBAAA;AAFV;AAKQ;EAAA;IACE,cAAA;IACA,cAAA;EAFR;AACF;AAxCA;EA8CM,cAAA;AAHN;AA3CA;EAkDM,aAAA;EACA,yBAAA;AAJN;AA/CA;EAuDQ,aAAA;EACA,uBAAA;AALR;AAnDA;EA2DU,iBAAA;AALV;AAtDA;EA+DU,iBAAA;AANV;AAYA;EACE;IAEI,0CAAA;EAXJ;AACF","sourcesContent":[".modal-terms-of-use {\n  max-height: 90vh;\n  max-width: 100%;\n  \n\n  .ant-modal-content {\n    padding: 15px;\n  }\n  .modal-terms-of-use-content {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .modal-terms-of-use-regulation {\n      max-height: 600px;\n      margin: 0 auto;\n      overflow-x: auto;\n      width: 100%;\n      height: 100%;\n    }\n\n    .title {\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 28px;\n      margin-bottom: 0;\n    }\n\n    .icon-show-terms {\n      font-style: normal;\n      display: flex;\n      cursor: pointer;\n      max-width: 20%;\n      \n        .anticon-left{\n          margin-right: 3px;\n        }\n\n        @media screen and (max-width: 370px){\n          font-size: 8px;\n          max-width: 30%;\n        }\n    }\n\n    .icon-show-terms:hover{\n      color: #0059ff;\n    }\n\n    .modal-terms-of-use-buttons-container {\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    .container-checkbox{\n        display: flex;\n        justify-content: center;\n\n        .ant-checkbox {\n          margin-right: 8px;\n        }\n\n        .txt-terms{\n          font-weight: bold;\n        }\n    }\n    \n  }\n}\n@media screen and (max-width: 480px) {\n  .modal-terms-of-use-recharge {\n    .ant-modal-content {\n      padding: var(--spacing-regular) !important;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
